import { TCPA } from "@lgp/shared/constants";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AppProvider from "./components/AppProvider";
import "./css/common.scss";

const { TCPA_APP_ID } = TCPA;

// The app can only run in an iframe.
if (window.location === window.parent.location) {
  throw new Error(`The app must be in an iframe.`);
}

// Create a React mount node if it does not exist.
const root = document.getElementById(TCPA_APP_ID);
if (!root) {
  throw new Error(`Root element ${TCPA_APP_ID} not found in DOM.`);
}

const url = new URL(window.location.href);
const urlSearchParams = url.searchParams;
const parentUrl = new URL(urlSearchParams.get("referrer"));
const parentHostUrlParts = parentUrl.href.split("/");
const parentHost = parentHostUrlParts[0] + "//" + parentHostUrlParts[2];
const configData = {};
if (urlSearchParams.get("companyName")) {
  configData.companyName = urlSearchParams.get("companyName");
}

// Render the React App.
function renderApp() {
  const app = ReactDOM.createRoot(root);
  app.render(
    <React.StrictMode>
      <AppProvider
        parentHost={parentHost}
        parentUrl={parentUrl}
        configData={configData}
      >
        <App />
      </AppProvider>
    </React.StrictMode>
  );
}

if (root) {
  window.addEventListener("DOMContentLoaded", renderApp);
}
